function setCookie(name, value, type) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    if(type){
        var x = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
    }else{
        var x = exp.toGMTString()
    }
    document.cookie = name + "=" + escape(value) + ";expires=" + x + ";path=/";
}

function getCookie(name) {
    // if (document.cookie.length > 0) {
    //     let start = document.cookie.indexOf(name + "=")
    //     if (start != -1) {
    //         start = start + name.length + 1;
    //         let end = document.cookie.indexOf(";", start);
    //         if (end == -1) end = document.cookie.length
    //         return unescape(document.cookie.substring(start, end))
    //     }
    // }
    // return null;
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return null;
}
//清除cookie
function clearCookie() {
    this.setCookie("username", "", -1);
}
export default {
    setCookie,
    getCookie,
    clearCookie,
}


//////////////////
// WEBPACK FOOTER
// ./commonApi.js
// module id = null
// module chunks = 